import { render, staticRenderFns } from "./lookover.vue?vue&type=template&id=4d6c9e08&scoped=true"
import script from "./lookover.vue?vue&type=script&lang=js"
export * from "./lookover.vue?vue&type=script&lang=js"
import style0 from "./lookover.vue?vue&type=style&index=0&id=4d6c9e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c9e08",
  null
  
)

export default component.exports